import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export let ActionStatus = /*#__PURE__*/function (ActionStatus) {
  ActionStatus["UNKNOWN"] = "UNKNOWN";
  ActionStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  ActionStatus["IN_PROGRESS"] = "IN_PROGRESS";
  ActionStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
  ActionStatus["COMPLETE"] = "COMPLETE";
  ActionStatus["CANCELED"] = "CANCELED";
  ActionStatus["INVALID"] = "INVALID";
  ActionStatus["FAILED"] = "FAILED";
  return ActionStatus;
}({});
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["UNKNOWN"] = "UNKNOWN";
  ActionType["SCHEDULE_MEETING"] = "SCHEDULE_MEETING";
  ActionType["EDIT_MEETING"] = "EDIT_MEETING";
  ActionType["CANCEL_MEETING"] = "CANCEL_MEETING";
  ActionType["CREATE_RECURRING_SCHEDULE"] = "CREATE_RECURRING_SCHEDULE";
  ActionType["EDIT_RECURRING_SCHEDULE"] = "EDIT_RECURRING_SCHEDULE";
  ActionType["CANCEL_RECURRING_SCHEDULE"] = "CANCEL_RECURRING_SCHEDULE";
  ActionType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
  return ActionType;
}({});
export const isValidAction = properties => {
  return isValidBase(properties) && validateProps(properties, ['guidelines', 'taskId', 'status', 'actionType', 'details']);
};
//# sourceMappingURL=Action.js.map